import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_ME } from '../graphql/getMe';

interface UnauthRouteProps {
  element: React.ReactElement;
  redirectTo?: string;
}

const UnauthRoute: React.FC<UnauthRouteProps> = ({
  element,
  redirectTo = '/dashboard',
}) => {
  const { data: me, loading } = useQuery(GET_ME);
  const location = useLocation();

  if (loading) {
    return null;
  }

  if (me?.getMe) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return element;
};

export default UnauthRoute;
